import React from "react";
import { Route, Routes } from "react-router-dom";
import SideMenu from "../components/menu/SideMenu";
import Dashboard from "../container/Dashboard";
import PatientSearch from "../container/PatientSearch";
import Claims from "../container/Claims";
import Applications from "../container/Applications";
import PreQualification from "../container/PreQualification";
import ReactWizard from "../components/wizard/ReactWizard";
import AppIntake from "../container/AppIntake";
import Cases from "../container/Cases";
import PageNotFound from "../container/PageNotFound";
import ClaimIntake from "../container/ClaimIntake";
import ProtectRoute from "../container/ProtectRoute";
import { useSelector } from "react-redux";
import { login } from "../stores/slices/loginSlice";
import Appdetails from "../container/ApplicationViewPage/Appdetails";
import Registration from "../container/Registration";
import ForgetPassword from "../components/login/ForgetPassword"
import UpdatePassword from "../components/login/UpdatePassword";
import Successful from "../components/registration/Successful";
import PassswordSuccess from "../components/login/PasswordSucces";
import Login from "../components/login/Login";
import TermsOfUse from "../components/btooltip/termsOfUse/TermsOfUse";
import ProgramDisclaimers from "../components/btooltip/programDisclaimers/ProgramDisclaimers";
import PrivacyAndComplaince from "../components/btooltip/privacyAndComplaince/PrivacyAndComplaince";
import ResetPasswordSuccess from "../components/login/ResetPasswordSuccess";
import PreQualDenial from "../container/preQualDenial";
import FinancialResourceDirectory from "../components/FinancialResourceDirectory/FinancialResourceDirectory";
import ClaimDetails from "../container/ClaimDetailsViewPage/ClaimDetails";
import LandingPage from "../container/LandingPage";
import EducationResourceDirectory from "../container/EducationResourceDirectory";
import Reports from "../container/Reports";
import CreateApplications from "../container/CreateApplications";
import VerifyEmail from "../components/login/VerifyEmail";
import Kill from "../components/kill/Kill";

function Router() {
  const isloggedin = useSelector(login);

  return (
    <div className={`${isloggedin && "d-flex display_content"}`}>
      {isloggedin && <SideMenu />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/termsofuse" element={<TermsOfUse />} />
        <Route path="/verifyEmail" element={<VerifyEmail />} />
        <Route path="/privacyandcomplaince" element={<PrivacyAndComplaince />} />
        <Route path="/programdisclaimers" element={<ProgramDisclaimers />} />
        <Route path="/forgetPassword" element={<ForgetPassword />} />
        <Route path="/confirmpassword" element={<UpdatePassword />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/successInformation" element={<Successful />} />
        <Route path="/passswordSuccess" element={<PassswordSuccess />} />
        <Route path="/resetPasswordSuccess" element={<ResetPasswordSuccess />} />
        <Route path="/kill" element={<Kill />} />
        <Route element={<ProtectRoute />}>
          <Route path="/applications" element={<Applications />} />
          <Route path="/dashboard" element={<LandingPage />} />
          <Route path="/createApp" element={<CreateApplications />} />
          <Route path="/searchPatient" element={<Dashboard />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/patientSearch" element={<PatientSearch />} />
          <Route path="/claims" element={<Claims />} />
          <Route path="/financialResourceDirectory" element={<FinancialResourceDirectory />} />
          <Route path="/educationResourceLibrary" element={<EducationResourceDirectory />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/profile" element={<Dashboard />} />
          <Route path="/createApp/prequal" element={<PreQualification />} />
          <Route path="/ReactWizard" element={<ReactWizard />} />
          <Route path="/createApp/appintake" element={<AppIntake />} />
          <Route path="/claims/claimintake" element={<ClaimIntake />} />
          <Route path="/applications/Details" element={<Appdetails />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/PreQualDenial" element={<PreQualDenial />} />
          <Route path="/claims/Details" element={<ClaimDetails />} />
        </Route>
      </Routes>
    </div>
  );
}

export default Router;
